module.exports = __webpack_public_path__ + "static/assets/abdb9221f6fe3367ae1d899e2352d2e3.svg";